import {CLEAR_CURRENT_REQUEST} from "../../../enums/Request/request.types";

export const clearCurrentRequestAction = () => {
    return {
        type: CLEAR_CURRENT_REQUEST,
    };
};
